// extracted by css-extract-rspack-plugin
var _1 = "Loading-m_container-BoLT5XkB";
var _2 = "Loading-m_fade-in-YA9nspkz";
var _3 = "Loading-m_loading-Ww7ONze0";
var _4 = "Loading-m_logo-animation-pop-_rav5HPy";
var _5 = "Loading-m_square-a77OTTle";
var _6 = "Loading-m_text-iDRNfPXM";
var _7 = "Loading-m_textContainer-deoW6WQx";
export { _1 as "container", _2 as "fadeIn", _3 as "loading", _4 as "logoAnimationPop", _5 as "square", _6 as "text", _7 as "textContainer" }
